module.exports = __webpack_public_path__ + "img/ereszkalkulator_kicsi_haz_l_nyeregteto_szurke.cd367422.png";